<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
              <span>就诊分析</span>
            </div>
<!--            <el-row :gutter="10">-->
<!--              <el-col :span="8">-->
<!--                <PieChart id="user_treat_hist_stat_pie"-->
<!--                          :params="{'patient_id':patient_id}"-->
<!--                          height="300px"-->
<!--                          width="100%"-->
<!--                          path="user_treat_hist_stat_pie"></PieChart>-->

<!--              </el-col>-->
<!--              <el-col :span="8">-->
<!--                <PieChart id="user_treat_hist_stat_clinic_pie"-->
<!--                          :params="{'patient_id':patient_id}"-->
<!--                          height="300px"-->
<!--                          width="100%"-->
<!--                          path="user_treat_hist_stat_clinic_pie"></PieChart>-->
<!--              </el-col>-->
<!--              <el-col :span="8">-->
<!--                <PieChart id="user_treat_hist_stat_drug_pie"-->
<!--                          :params="{'patient_id':patient_id}"-->
<!--                          height="300px"-->
<!--                          width="100%"-->
<!--                          path="user_treat_hist_stat_drug_pie"></PieChart>-->
<!--              </el-col>-->
<!--            </el-row>-->
            </el-card>
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
              <span>就诊花费</span>
            </div>
<!--            <el-row>-->

<!--              <LineChart id="user_treat_hist_line" path="user_treat_hist_line" height="300px" width="100%"-->
<!--                         :params="{'patient':this.patient_id}"></LineChart>-->
<!--            </el-row>-->
<!--            <el-row>-->
<!--              <el-table-->
<!--                  :data="user_treat_hist"-->
<!--                  height="600px"-->
<!--                  border-->
<!--                  stripe-->
<!--                  style="width: 100%">-->
<!--                <el-table-column prop="病症" label="病症"></el-table-column>-->
<!--                <el-table-column prop="医生名称" label="医生名称"></el-table-column>-->
<!--                <el-table-column prop="clinic_name" label="诊所名称"></el-table-column>-->
<!--                <el-table-column prop="时间" label="时间"></el-table-column>-->
<!--                <el-table-column prop="total_fee" label="总花费">-->
<!--                </el-table-column>-->
<!--              </el-table>-->
<!--            </el-row>-->
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import PieChart from "@/views/charts/pie";
// import LineChart from "@/views/charts/line";

export default {
  name: "Treatment",
  components: {
    // PieChart,
    // LineChart,
  },
  mounted() {
    this.get_user_treat_hist()
  },
  data() {
    return {
      user_treat_hist: null,
      patient_id: this.$route.query.patient_id ? this.$route.query.patient_id : (localStorage.getItem('user_id') ? localStorage.getItem('user_id') : '637377'),
    }
  },
  methods: {
    get_user_treat_hist() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/user_treat_hist?patient_id=" + this.patient_id).then((res) => {
        console.log(res);
        this.user_treat_hist = res.data.data
      })
    },
  }
}
</script>

<style scoped>

</style>
